import script from "./PwaInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./PwaInstructions.vue?vue&type=script&setup=true&lang=js"

import "./PwaInstructions.vue?vue&type=style&index=0&id=54052796&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_omnia_1776687441006616365/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54052796"]])

export default __exports__